export const STAFF_LIST = 'STAFF_LIST'; 
export const SELECTED_STAFF = 'SELECTED_STAFF';